import React, { Component } from 'react';
import { TabPanel } from 'primereact/components/tabview/TabView';

class ModalTabPanel extends Component {
  render() {
    return <TabPanel>{this.props.children}</TabPanel>;
  }
}

export default ModalTabPanel;



// WEBPACK FOOTER //
// ./src/components/common/modaltabpanel/ModalTabPanel.js